<a class="{{btnClass}} position-relative" [class.disabled]="isDisabled" (click)="onClickButton($event)">
  <div class="leading-icon">
    <ng-content></ng-content>
  </div>
  <span>{{label}}</span>
</a>
